import { connect } from 'react-redux';
import { selectors as configurationSelectors } from '../../ducks/configurationDuck';
import App from './App';

const mapStateToProps = state => ({
  locale: configurationSelectors.configuration(state).locale,
});

const AppContainer = connect(mapStateToProps)(App);
export default AppContainer;
